module.exports = __webpack_public_path__ + "static/media/YM64_4.0b8d79e8.jpg";